import type { IconSvgObject } from './types';

const DollarReceive02Icon: IconSvgObject = [
  ["path", { d: "M18 14.5L15.5 12L18 9.5M21.5 12H16.1088", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.0833 8.62963C12.0833 6.62504 10.0313 5 7.5 5C4.96869 5 2.91667 6.62504 2.91667 8.62963C2.91667 10.6342 4.16667 11.7407 7.5 11.7407C10.8333 11.7407 12.5 12.7778 12.5 15.3704C12.5 17.963 10.4167 19 7.5 19C4.58333 19 2.5 17.5 2.5 15.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default DollarReceive02Icon;
